/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalRoleResponseDto
 */
export interface ProposalRoleResponseDto {
    /**
     * User's role in the org
     * @type {string}
     * @memberof ProposalRoleResponseDto
     */
    role?: string;
    /**
     * User Id
     * @type {string}
     * @memberof ProposalRoleResponseDto
     */
    userId?: string;
    /**
     * Grand can be accepted rejected or in progress (null value)
     * @type {boolean}
     * @memberof ProposalRoleResponseDto
     */
    isAccepted?: boolean;
    /**
     * User Id
     * @type {string}
     * @memberof ProposalRoleResponseDto
     */
    proposedBy?: string;
    /**
     * User Id
     * @type {string}
     * @memberof ProposalRoleResponseDto
     */
    approvedBy?: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof ProposalRoleResponseDto
     */
    orgId?: string;
    /**
     * Is role accepted or not
     * @type {string}
     * @memberof ProposalRoleResponseDto
     */
    roleProposalStatus?: string;
    /**
     * When the grant was proposed
     * @type {string}
     * @memberof ProposalRoleResponseDto
     */
    proposedDate?: string;
    /**
     * When the grant was approved
     * @type {string}
     * @memberof ProposalRoleResponseDto
     */
    grantDate?: string;
}

/**
 * Check if a given object implements the ProposalRoleResponseDto interface.
 */
export function instanceOfProposalRoleResponseDto(value: object): boolean {
    return true;
}

export function ProposalRoleResponseDtoFromJSON(json: any): ProposalRoleResponseDto {
    return ProposalRoleResponseDtoFromJSONTyped(json, false);
}

export function ProposalRoleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalRoleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'role': json['role'] == null ? undefined : json['role'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'isAccepted': json['isAccepted'] == null ? undefined : json['isAccepted'],
        'proposedBy': json['proposedBy'] == null ? undefined : json['proposedBy'],
        'approvedBy': json['approvedBy'] == null ? undefined : json['approvedBy'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'roleProposalStatus': json['Role proposal status'] == null ? undefined : json['Role proposal status'],
        'proposedDate': json['proposedDate'] == null ? undefined : json['proposedDate'],
        'grantDate': json['grantDate'] == null ? undefined : json['grantDate'],
    };
}

export function ProposalRoleResponseDtoToJSON(value?: ProposalRoleResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'role': value['role'],
        'userId': value['userId'],
        'isAccepted': value['isAccepted'],
        'proposedBy': value['proposedBy'],
        'approvedBy': value['approvedBy'],
        'orgId': value['orgId'],
        'Role proposal status': value['roleProposalStatus'],
        'proposedDate': value['proposedDate'],
        'grantDate': value['grantDate'],
    };
}

